<template lang="pug">
.container.grid-lg
  .card.mt-2
    .card-header
      .text-bold Filtrar
    .card-body
      form-filter(@submit="fetchReport" initializePeriodo)
  .full-height.loading.loading-lg(v-if="loading")
  div(v-else-if="report")
    div(v-if="report.data && Object.values(report.data).length")
      card-group-data(
        :report="report",
        label-items="Dias",
        label-total="Total de todos fiscais"
      )
    .card.mt-2(v-else)
      .card-body
        .empty
          .empty-icon
            i.fa.fa-search.fa-4x
          p.empty-title.h5 Nada encontrado
          p.empty-subtitle Não foram encontradas OS-m neste período
</template>

<script>
import toastErrors from "@/lib/errors/toastErrors"
import ordemServicos from "@/api/indicadores/ordemServicos"
import FormFilter from "./components/Filter"
import CardGroupData from "./components/ReposrtCardGroupData"

export default {
  data() {
    return {
      loading: false,
      report: null,
    }
  },
  components: { FormFilter, CardGroupData },
  methods: {
    async fetchReport(q = {}) {
      try {
        this.loading = true
        this.report = await ordemServicos.fiscaisPorDias({ q })
      } catch (error) {
        toastErrors(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
